import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const FieldWrap = ({ id, label, required, hint, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label htmlFor={id} className="text-[13px] font-medium text-slate-700">
      {label} {required && <span className="text-[#C20500]">*</span>}
    </Label>
    {children}
    {hint && <p className="text-xs text-slate-500">{hint}</p>}
  </div>
);

export const TextField = ({ id, label, value, onChange, required, type = "text", hint, className, ...rest }) => (
  <FieldWrap id={id} label={label} required={required} hint={hint} className={className}>
    <Input
      id={id}
      data-testid={`${id}-input`}
      type={type}
      value={value ?? ""}
      required={required}
      onChange={(e) => onChange(e.target.value)}
      className="h-11 bg-white"
      {...rest}
    />
  </FieldWrap>
);

export const TextAreaField = ({ id, label, value, onChange, required, rows = 4, hint, className, ...rest }) => (
  <FieldWrap id={id} label={label} required={required} hint={hint} className={className}>
    <Textarea
      id={id}
      data-testid={`${id}-input`}
      value={value ?? ""}
      rows={rows}
      required={required}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white"
      {...rest}
    />
  </FieldWrap>
);

export const SelectField = ({ id, label, value, onChange, options, required, placeholder = "Select", className }) => (
  <FieldWrap id={id} label={label} required={required} className={className}>
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger id={id} data-testid={`${id}-select`} className="h-11 bg-white">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((o) => {
          const val = typeof o === "string" ? o : o.value;
          const lab = typeof o === "string" ? o : o.label;
          return (
            <SelectItem key={val} value={val} data-testid={`${id}-option-${String(val).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              {lab}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  </FieldWrap>
);

export const FormSection = ({ step, title, children }) => (
  <fieldset className="grid gap-5 border-t border-slate-200 pt-8 first:border-t-0 first:pt-0 sm:grid-cols-2">
    <legend className="col-span-full mb-1 flex items-center gap-3 text-sm font-semibold text-slate-900">
      <span className="mono rounded bg-slate-900 px-2 py-0.5 text-[11px] text-white">{step}</span>
      {title}
    </legend>
    {children}
  </fieldset>
);
